<router-outlet />
<fu-dev-breakpoint-badge />
